import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5060360f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-upload"
};
const _hoisted_2 = {
  class: "app-item"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "description-text"
};
const _hoisted_5 = {
  class: "description-list"
};
const _hoisted_6 = {
  class: "d-title"
};
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
  class: "app-item"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "Android", -1));
const _hoisted_10 = {
  class: "description-text"
};
const _hoisted_11 = {
  class: "description-list"
};
const _hoisted_12 = {
  class: "d-title"
};
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = {
  class: "app-item"
};
const _hoisted_15 = {
  class: "description-text"
};
const _hoisted_16 = {
  class: "description-list"
};
const _hoisted_17 = {
  class: "d-title"
};
const _hoisted_18 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('message.pc')), 1), _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('message.pcDescribe')), 1), _createElementVNode("div", {
    class: "btn",
    onClick: _cache[0] || (_cache[0] = $event => $setup.clickDownLoad('pc'))
  }, _toDisplayString(_ctx.$t('message.download')), 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('message.versionDescribe')) + "：", 1), _createElementVNode("p", {
    innerHTML: $setup.getHtml($props.app.pc ? $props.app.pc.description || '' : '')
  }, null, 8, _hoisted_7)])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('message.androidDescribe')), 1), _createElementVNode("div", {
    class: "btn",
    onClick: _cache[1] || (_cache[1] = $event => $setup.clickDownLoad('android'))
  }, _toDisplayString(_ctx.$t('message.download')), 1), _createElementVNode("div", _hoisted_11, [_createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('message.versionDescribe')) + "：", 1), _createElementVNode("p", {
    innerHTML: $setup.getHtml($props.app.android ? $props.app.android.description || '' : '')
  }, null, 8, _hoisted_13)])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("p", {
    class: "title",
    onClick: _cache[2] || (_cache[2] = $event => $setup.clickDownLoad('ios'))
  }, "iOS"), _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('message.iosDescribe')), 1), _createElementVNode("div", {
    class: "btn",
    onClick: _cache[3] || (_cache[3] = $event => $setup.clickDownLoad('ios'))
  }, _toDisplayString(_ctx.$t('message.download')), 1), _createElementVNode("div", _hoisted_16, [_createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('message.versionDescribe')) + "：", 1), _createElementVNode("p", {
    innerHTML: $setup.getHtml($props.app.android ? $props.app.ios.description || '' : '')
  }, null, 8, _hoisted_18)])])]);
}